<template>
  <div>
    <!-- <div id="aaa"></div> -->
    <!--选择影像中心开始-->
    <van-nav-bar left-arrow @click-left="onClickLeft">
      <div slot="title">
        <van-dropdown-menu active-color="#323233">
          <van-dropdown-item
            v-model="agentErpCode"
            :options="agentList"
            title-class="icon"
            @change="changeAgent"
            @open="openmenu"
            @close="closemenu"
          />
        </van-dropdown-menu>
      </div>
    </van-nav-bar>

    <!--选择影像中心结束-->

    <div v-if="toggle">
      <!--搜索开始-->

      <van-row>
        <van-col span="24">
          <form action="/">
            <van-search
              v-model="value"
              placeholder="耗材名称/品牌"
              show-action
              shape="round"
              @search="onSearch"
            >
              <div slot="action" @click="onSearch(value)">搜索</div>
            </van-search>
          </form>
        </van-col>
      </van-row>
      <!--搜索结束-->

      <!--导航栏开始-->
      <van-tabs
        v-model="activeName"
        sticky
        :border="false"
        @click="changeCk"
        title-active-color="#323233"
      >
        <van-tab
          v-for="(cangku_item, cangku_index) in cangku"
          :key="cangku_index"
          :title="cangku_item.warehouse_name"
          :name="cangku_item.warehouse_name"
        >
          <van-row v-if="parseTabbarAll[0]" type="flex">
            <van-col span="6">
              <van-sidebar
                :style="classObject"
                v-model="activeKey"
                @change="onChange"
              >
                <van-sidebar-item
                  v-for="(item, index) in category"
                  :key="index"
                  :title="item.category_name"
                />
              </van-sidebar>
            </van-col>
            <van-col span="18" :style="classObject">
              <div
                class="van-cell-group van-hairline--top-bottom van-panel"
                v-for="(consumable, index) in parseTabbarAll"
                :key="index"
              >
                <div
                  class="van-cell van-panel__header"
                  v-if="
                    cangku_item.warehouse_name == '全部' ||
                    consumable.warehouse_name == cangku_item.warehouse_name
                  "
                >
                  <div class="van-cell__title">
                    <div>
                      <span>{{ consumable.modelname }}</span>
                    </div>
                    <div class="van-cell__label">
                      品牌：{{ consumable.brandname }}
                    </div>
                    <div class="van-cell__label">
                      仓库：{{ consumable.warehouse_name }}
                    </div>
                    <div class="van-cell__label">
                      <van-tag plain type="warning"
                        >预警值：{{ consumable.warning_value }}</van-tag
                      >&nbsp;
                      <van-tag v-if="consumable.is_gift!=1" plain type="warning">赠品</van-tag>
                    </div>
                  </div>

                  <div class="van-cell__value van-panel__header-value">
                    <span>{{ consumable.quantity + consumable.unit }}</span>
                  </div>
                </div>
              </div>
              <div id="ccc"></div>
            </van-col>
          </van-row>
          <van-empty v-else description="暂无数据" />
        </van-tab>
      </van-tabs>
    </div>
    <!--导航栏结束-->
    <Bottom></Bottom>
  </div>
</template>

<script>
import Bottom from "../../view/bottom/index.vue";
import Vue from "vue";
import {
  Tag,
  Sidebar,
  SidebarItem,
  IndexBar,
  IndexAnchor,
  NavBar,
  Tab,
  Tabs,
  Panel,
  Search,
  Tabbar,
  TabbarItem,
  Icon,
  DropdownMenu,
  DropdownItem,
} from "vant";
import { Row, Col, Empty } from "vant";
import { mapState, mapMutations } from "vuex";
Vue.use(Col).use(Panel);
Vue.use(Icon);
Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(IndexBar).use(IndexAnchor);
Vue.use(NavBar);
Vue.use(Tag);
Vue.use(Tabs);
Vue.use(Search);
Vue.use(Tabbar).use(TabbarItem);
Vue.use(DropdownMenu).use(DropdownItem);
export default {
  components: {
    Bottom,
    [Tab.name]: Tab,
    [Row.name]: Row,
    [Empty.name]: Empty,
  },

  data() {
    return {
      scroll: "scroll",
      contentheight: "",
      height: "",
      activeKey: -1,
      activeName: "全部",
      value: "",
      currentAgent: "",
      agentErpCode: 0,
      agentList: [],
      cangku: [],
      //左侧导航栏分类
      category: [],
      //全部耗材品种
      tabbarAll: [],
      parseTabbarAll: [],
      toggle: false,
    };
  },

  computed: {
    ...mapState(["permissionAgent", "defaultAgentIndex"]),
    classObject: function () {
      return {
        "overflow-y": "scroll",
        height: this.height,
      };
    },
  },

  methods: {
    ...mapMutations(["changePermissionAgent", "changeDefaultAgentIndex"]),
    onClickLeft() {
      history.go(-1);
    },
    openmenu() {
      this.toggle = false;
    },
    closemenu() {
      if (this.agentErpCode) {
        this.toggle = true;
      }
    },
    onChange(index) {
      this.parseTabbarAll = this.tabbarAll;
      this.value = "";
      //this.onCancel();
      let val = this.category[index].category_name;
      this.parseTabbarAll = this.tabbarAll.filter(function (elem) {
        return elem.category_name.indexOf(val) > -1;
      });
    },
    changeCk(name, title) {
      if (title == "全部") {
        this.value = "";
        this.activeKey = -1;
        this.parseTabbarAll = this.tabbarAll;
      }
    },
    onSearch(val) {
      this.activeKey = -1;
      this.parseTabbarAll = this.initSearchList(val);
    },
    initSearchList(val) {
      if (!val) {
        //window.console.log(this.permissionAgent);
        return this.tabbarAll;
      } else {
        //let _this = this;
        //window.console.log(this.tabbarAll);
        return this.tabbarAll.filter(function (elem) {
          return (
            elem.modelname.indexOf(val) > -1 || elem.brandname.indexOf(val) > -1
          );
        });
        //window.console.log(ses);
      }
    },
    parseAgentList(obj) {
      let newarr = [
        {
          text: "请选择影像中心",
          value: 0,
        },
      ];
      //let newarr = [];
      for (let i = 0; i < obj.length; i++) {
        let newobj = {
          text: obj[i].name,
          value: obj[i].erp_code,
        };
        newarr.push(newobj);
      }
      return newarr;
    },
    initCangku(obj) {
      let newcangku = [
        {
          warehouse_name: "全部",
        },
      ];
      for (let i = 0; i < obj.length; i++) {
        newcangku.push({
          warehouse_name: obj[i].warehouse_name,
        });
      }
      return newcangku;
    },
    initCategory(obj) {
      let newCategory = [];
      if (obj) {
        for (let i = 0; i < obj.length; i++) {
          if (
            !newCategory.find((item) => {
              return item.category_name == obj[i].category_name;
            })
          ) {
            newCategory.push({
              category_name: obj[i].category_name,
              category_id: obj[i].category_id,
            });
          }
        }
      }

      return newCategory;
    },
    changeAgent(value) {
      let _this = this;
      if (value) {
        this.currentAgent = this.permissionAgent.find(function (item) {
          return item.erp_code == value;
        });
        this.cangku = this.initCangku(this.currentAgent.warehouse);
        this.$http
          .post("/mobile/stockList", {
            projectErpCode: value,
          })
          .then(function (response) {
            //window.console.log(response);
            _this.category = _this.initCategory(response.stock);
            _this.tabbarAll = response.stock;
            _this.parseTabbarAll = _this.tabbarAll;
          });
      }
    },
  },
  created() {
    if (this.permissionAgent) {
      this.agentList = this.parseAgentList(this.permissionAgent);
    } else {
      let _this = this;
      this.$http
        .post("/mobile/rimsAgentList", {
          username: localStorage.getItem("usermobile"),
        })
        .then(function (response) {
          _this.changePermissionAgent(response.rimsAgent);
          _this.changeDefaultAgentIndex(response.rimsAgent[0].id);
          _this.agentList = _this.parseAgentList(_this.permissionAgent);
        });
    }

    // window.console.log(this.defaultAgentIndex);
  },
  mounted() {
    this.height = document.documentElement.clientHeight - 260 + "px";
    this.contentheight = document.documentElement.clientHeight - 200 + "px";
  },
};
</script>

<style lang="less" scopt>
#aaa {
  width: 100vw;
  height: 46px;
}
#bbb {
  width: 100vw;
  height: 40px;
}
#ccc {
  height: 50px;
}
.van-nav-bar__title {
  font-weight: 800;
  color: #323233;
}
.van-nav-bar .van-icon {
  color: rgba(0, 0, 0, 0.7);
}
.van-dropdown-menu {
  height: 46px;
}
.van-tab__pane,
.van-tab__pane-wrapper {
  height: 507px;
  overflow-y: scroll;
}
</style>
